import { useQuery } from '@tanstack/react-query';
import { FieldValues } from 'react-hook-form';

import { chapterTypeOptions } from '@/module/Nomen/ChapterType/model/ChapterTypeModel';

import { AsyncSelectControl, AsyncSelectControlProps } from '@/core/components';

type ChapterTypeSelectControlProps<T extends FieldValues> = Omit<
  AsyncSelectControlProps<T>,
  'isError' | 'isLoading' | 'options'
>;

export function ChapterTypeSelectControl<T extends FieldValues>(props: ChapterTypeSelectControlProps<T>) {
  const { data, isLoading, isError } = useQuery(chapterTypeOptions.getAll());

  return (
    <AsyncSelectControl
      isError={isError}
      isLoading={isLoading}
      options={data ?? []}
      {...props}
    />
  );
}
